import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { createAppThunk, type IRes } from "store/modules/common";
import Http from "commons/Http";
import { API_USER } from "config/api";

import type { IPageInfo } from "pages/notice/store/NoticeVo";
import type { IRadioItem } from "components/ui/RadioGroup";
import { dataUrlToBlob } from "commons/utils";
import type { IMemeberVo, IResMemberList } from "./memberVo";
import type { IUserList, IUserUpdateFetc } from "../store/UserVo";

const name = "member";

export interface IMember {
  list: IMemeberVo[];
  page_info?: IPageInfo;
}

/**
 * 유저 목록 리스트 조회
 */
export const apiGuserMemberList = createAppThunk<
  IResMemberList,
  { page: number; size?: number; type?: string; search?: string }
>(`${name}/apiGuserMemberList`, async (params, thunkApi) => {
  params.size = thunkApi.getState().member.page_info!.size;
  const res = await Http.get<IRes<IResMemberList>>(`${API_USER}/list`, {
    params,
  });

  if (res.data.content) {
    thunkApi.dispatch(
      rdxSetUserPageInfo({
        page: res.data.content.data.page_info.page,
        size: 20,
        total_elements: res.data.content.data.page_info.total_elements,
        totalPage: Math.ceil(res.data.content.data.page_info.total_elements! / 20),
      }),
    );
    thunkApi.dispatch(rdxSetUserList(res.data.content.data.list));
  }
  return res.data;
});

// 유저 비밀번호 수정
export const apiPuserPasswdReset = createAppThunk<IUserList, IUserUpdateFetc>(
  `${name}/apiPupdateUser`,
  async (param, _) => {
    const res = await Http.post<IRes<IUserList>>(`${API_USER}/update/${param.id}`, param);
    return res.data;
  },
);

const userSlice = createSlice({
  name,
  initialState: {
    list: [],
    page_info: {
      total_elements: 0,
      page: 0,
      size: 20,
      totalPage: 0,
    },
    isLoading: false,
  } as IMember,
  reducers: {
    rdxSetUserPageInfo(state: IMember, action: PayloadAction<IPageInfo>) {
      state.page_info = action.payload;
    },
    rdxSetUserList(state: IMember, action: PayloadAction<IMemeberVo[]>) {
      state.list = action.payload;
    },
  },
  extraReducers: builder => {
    // builder.addCase(apiGuserInfo.pending, state => {
    //   state.isLoading = true;
    // });
    // builder.addCase(apiGuserInfo.fulfilled, state => {
    //   state.isLoading = false;
    // });
  },
});

export const { rdxSetUserPageInfo, rdxSetUserList } = userSlice.actions;
// data 를 관리하는 reducer 기본 반환 설정
export default userSlice.reducer;
